var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"ref-chapter-3"},[_c('RefAnchorNav',{attrs:{"section":3}}),_c('Footer'),_c('img',{staticClass:"footer-corn",attrs:{"src":require("@/assets/fes-corn-wave.svg")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }